<a [routerLink]="[btnLink]" [ngClass]="btnClass" class="{{isdisabled ? 'disabled':''}}">
    <i [ngClass]="btnIcon"></i>
    <span [ngClass]="spanClass" [innerHTML] ="sanitizer.bypassSecurityTrustHtml(btnName)"></span>
</a>